// This component will be sent props for the image Source and the alt. I may later style this component 
function Skill({source, alt, title}) {
    return  <img src={source} alt={alt} title={title}/>
}

export default Skill
